<template>
  <div id="terms-card">
    <div>
      <div
        v-if="end_date_title"
        class=" h4-headline pb-3"
        data-qa="end_date_title">
        {{ typeof end_date_title == 'string' ? end_date_title : $t('Tenders.CompletionProposals') }}
      </div>
      <div
        class="flex"
        :class="innerValidate ? 'px-1' : 'px-0'">
        <DateMenu
          ref="menu_date_end"
          :change-date="changePropDate"
          data-qa="date-menu-forAcceptingProposals"
          :date-month.sync="end_date_month"
          :error="(innerValidate && !!proposals_min) || !!end_date_error"
          :min_date="minimum_prop_date"
          :min_date_for="$t('Tenders.ForAcceptingProposals')"
          :min_error="innerValidate ? proposals_min : null "
          :text_field_label="end_date_text"
          :value.sync="end_date"
          with_allowed_dates/>
        <TimeMenu
          data-qa="time-menu-endTime"
          :disabled="!$can('edit', 'EndTime')"
          :label="$t('Tenders.EndTime')"
          max="18:00:00"
          min="08:00:00"
          :time.sync="end_time"
          @changed="changeEndTime"/>
      </div>
      <template v-if="publish_btn && !$can('set', 'tenderPublicationPlaningMode', 'DISABLE')">
        <sButton
          class="h9-text-bold px-2 mt-4"
          data-qa="btn-scheduleAutomaticTenderPublication"
          icon="import"
          icon-class="mr-1"
          small
          type="text"
          @click="scheduleStart">
          {{ planned_publishing ? $t('Tenders.TurnOffScheduledPublishing') : $t('Tenders.ScheduleAutomaticTenderPublication') }}
        </sButton>
        <div
          v-if="planned_publishing"
          class="px-1 flex">
          <DateMenu
            ref="menu_date_plan"
            :change-date="changePlanDate"
            data-qa="date-menu-dublicationDate"
            :date-month.sync="planned_date_month"
            :min_date="today.format('YYYY-MM-DD')"
            :min_error="min_plnned"
            :text_field_label="$t('Tenders.PublicationDate')"
            :value.sync="planned_date"/>
          <TimeMenu
            data-qa="time-menu-publicationTime"
            :label="$t('Tenders.PublicationTime')"
            :time.sync="planned_time"
            @changed="changePlanTime"/>
        </div>
      </template>
    </div>
    <div
      v-if="useDateRange"
      class="pt-4">
      <slot name="second_name">
        <div
          class="h4-headline pb-3"
          data-qa="delivery-date-text">
          {{ $t(delivery_date_text) }}
        </div>
      </slot>
      <div
        v-if="innerValidate"
        class="h8-text text-lowercase pb-2 opacity-6"
        data-qa="not-necessarily">
        {{ $t('Tenders.NotNecessarily') }}
      </div>
      <div>
        <DateRangeDialog
          class="px-1"
          :fixed-value="fixed_value"
          :options="{from: {min: endDate}, to: {min: endDate}}"
          :search.sync="searched_period"
          :show-periods="false"
          @apply="apply"
          @clear="clearDelivery">
          <template #activator="{ on, open: openDate }">
            <div class="flex">
              <DateChip
                data-qa="date_chip_from"
                :date="date_from_format"
                :on="on"
                :placeholder="$t('Tenders.ForStartOfDelivery')"
                @click="openDate"/>
              <DateChip
                class="ml-6"
                data-qa="date_to_format"
                :date="date_to_format"
                :on="on"
                :placeholder="$t('Tenders.ForEndOfDelivery')"
                @click="open"/>
            </div>
          </template>
        </DateRangeDialog>
      </div>
      <div
        v-if="errorDate"
        class="h8-text pl-3 secondary__red--text">
        {{ errorDate }}
      </div>
    </div>
  </div>
</template>
<script>
import TimeMenu from 'components/common/inputs/TimeMenu.vue'
import DateMenu from 'components/common/inputs/DateMenu.vue'
import DateChip from 'components/common/elements/DateChip.vue'
import DateRangeDialog from 'components/common/dialogs/DateRangeDialog.vue'

import moment from 'moment'
import { datePickerMixin, tenderMixin } from 'mixins'

export default {
  name: 'termsCard',
  mixins: [ tenderMixin, datePickerMixin ],
  data() {
    return {
      today: moment(),
      end_date_month: null,
      planned_publishing: false,
      planned_date_month: null,
      planned_time: moment().add(1, 'hours').format('HH:mm'),
      end_time: null,
      time_menu: false,
      min_plnned: '',
      searched_period: [],
    }
  },
  props: {
    endDate: String,
    plannedDate: String,
    time: String,
    dateFrom: String,
    dateTo: String,
    fixed_value: String,
    publish_btn: {
      type: Boolean,
      default: () => true
    },
    end_date_title: {
      type: [Boolean, String],
      default: () => true
    },
    end_date_text: {
      type: String,
      default: () => 'Tenders.EndDate'
    },
    delivery_date_text: {
      type: String,
      default: () => 'Tenders.DeliveryTimeTitle'
    },
    /**
   * Валидировать данные силами компонента
   */
    innerValidate: {
      type: Boolean,
      default: true
    },
    /**
   * Отображать компонент delivery-date
   */
    useDateRange: {
      type: Boolean,
      default: true
    },
    end_date_error: [String, Boolean],
    minimalDate: {
      type: Date
    }
  },
  created() {
    this.end_date_month = moment(this.endDate).format('YYYY-MM')
    this.planned_date_month = moment(this.planned_date || this.endDate).format('YYYY-MM')
    this.searched_period = [this.date_from , this.date_to]
  },
  computed: {
    minimum_prop_date() {
      return this.minimalDate ? moment(this.minimalDate).format('YYYY-MM-DD') : this.min_date.format('YYYY-MM-DD')
    },
    min_period_date_format() {
      return this.end_date < this.min_date.format('YYYY-MM-DD') ? this.min_date.format('YYYY-MM-DD') : this.end_date
    },
    end_date: {
      get() {
        let date = this.endDate ? moment(this.endDate).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
        //this.end_time = this.endDate ? moment(this.endDate).format('HH:mm') : moment().format('HH:mm')
        this.$set(this, 'end_time', this.endDate ? moment(this.endDate).format('HH:mm') : moment().format('HH:mm'))
        this.changePropDate(date)
        return date
      },
      set(val) {
        this.updateDate(val, this.end_time, 'endDate')
        // this.$emit('update:endDate', val)
      }
    },
    planned_date: {
      get() {
        let date = this.plannedDate ? moment(this.plannedDate).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
        // this.changePropDate(date)
        //this.planned_time = (this.plannedDate ? moment(this.plannedDate) : moment().add(1, 'hours')).format('HH:mm')
        this.$set(this, 'planned_time', (this.plannedDate ? moment(this.plannedDate) : moment().add(1, 'hours')).format('HH:mm'))
        this.setMinPlanned()
        return date
      },
      set(val) {
        this.updateDate(val, this.planned_time, 'plannedDate')
      }
    },
    date_from: {
      get() {
        if (!parseFloat(this.dateFrom)) {
          return null
        }
        return moment(this.dateFrom).format('YYYY-MM-DD')
      },
      set(val) {
        this.$emit('update:dateFrom', val ? moment(val).format('YYYY-MM-DDTHH:mm:ss') : val)
      }
    },
    date_to: {
      get() {
        if (!parseFloat(this.dateTo)) {
          return null
        }
        return moment(this.dateTo).format('YYYY-MM-DD')
      },
      set(val) {
        this.$emit('update:dateTo', val ? moment(val).format('YYYY-MM-DDTHH:mm:ss') : val)
      }
    },
    end_date_format: {
      get() {
        if (moment(this.end_date).isValid()) {
          return moment(this.end_date).format('DD.MM.YYYY')
        }
        return ''
      },
      set(newValue) {
        this.end_date = moment(newValue, 'DD.MM.YYYY').format('YYYY-MM-DD')
      }
    },
    date_from_format: {
      get() {
        if (!parseFloat(this.date_from)) {
          return null
        }
        if (moment(this.date_from).isValid()) {
          return moment(this.date_from).format('DD.MM.YYYY')
        }
        return ''
      },
      set(newValue) {
        if (!parseFloat(newValue)) {
          return this.date_from = newValue
        }
        this.date_from = moment(newValue, 'DD.MM.YYYY').format('YYYY-MM-DD')
      }
    },
    date_to_format: {
      get() {
        if (!parseFloat(this.date_to)) {
          return null
        }
        if (moment(this.date_to).isValid()) {
          return moment(this.date_to).format('DD.MM.YYYY')
        }
        return ''
      },
      set(newValue) {
        if (!parseFloat(newValue)) {
          return this.date_to = newValue
        }
        this.date_to = moment(newValue, 'DD.MM.YYYY').format('YYYY-MM-DD')
      }
    },
    errorDate() {
      if (!this.innerValidate) { return null }
      const errorDateFrom = this.checkDate(this.end_date, this.date_from)
      const errorDateTo = this.checkDate(this.date_from || this.end_date, this.date_to)
      if (!errorDateFrom && !errorDateTo) { return null }
      if (errorDateFrom) {
        return this.$t('Validate.WrongProposalsDate', { date: errorDateFrom, for: this.$t('Tenders.ForStartOfDelivery') })
      }
      return this.$t('Validate.WrongProposalsDate', { date: errorDateTo, for: this.$t('Tenders.ForEndOfDelivery') })
    }
  },
  methods: {
    scheduleStart() {
      this.planned_publishing = !this.planned_publishing
      this.changePlanDate(this.planned_publishing ? this.planned_date : null)
    },
    setMinPlanned() {
      let time = moment()
      if (this.plannedDate && moment(this.plannedDate).format('YYYY-MM-DDHH:mm') < time.format('YYYY-MM-DDHH:mm')) {
        this.min_plnned = time.format('YYYY.MM.DD HH:mm')
      } else {
        this.min_plnned = null
      }
    },
    apply() {
      this.date_to = this.searched_period[1]
      this.date_from = this.searched_period[0]
    },
    checkDate(min, date) {
      if (date && moment(min) > moment(date)) {
        return moment(min).format('DD.MM.YYYY')
      }
    },
    changeDeliveryTo(date) {
      this.$refs.menu_date_to.$refs.menu.save(date)
    },
    changeDeliveryFrom(date) {
      this.$refs.menu_date_from.$refs.menu.save(date)
      this.date_to_month = this.date_to || date
    },
    changePropDate(date) {
      this.$refs.menu_date_end?.$refs.menu?.save(date)
    },
    changeEndTime() {
      this.updateDate(this.end_date, this.end_time, 'endDate')
    },
    changePlanDate(date) {
      this.$refs.menu_date_plan?.$refs.menu?.save(date)

      if (date) {
        this.$store.dispatch('setMinPproposalsDate', date + 'T' + this.planned_time)
      } else {
        this.$store.dispatch('setMinPproposalsDate',)
      }
      this.end_date_month = date
      this.updateDate(date, this.planned_time, 'plannedDate')
    },
    changePlanTime() {
      if (this.planned_date) {
        this.$store.dispatch('setMinPproposalsDate', this.plannedDate)
      }
      this.updateDate(this.planned_date, this.planned_time, 'plannedDate')
    },
    updateDate(date, time, type) {
      if (date) {
        this.$emit(`update:${type}`, date + 'T' + time + ':00')
      } else {
        this.$emit(`update:${type}`, null)
      }
    },
    open() {
      this.$refs.menu?.open
    },
    save (date) {
      this.$refs.menu?.save(date)
    },
    clearDelivery() {
      this.searched_period = [this.date_from , this.date_to]
    }
  },
  components: {
    DateChip,
    TimeMenu,
    DateMenu,
    DateRangeDialog
  }
}
</script>
<style lang="scss">
#terms-card {
 .date-chip {
  cursor: pointer;
 }
 .data-field {
  width: 172px;
  max-width: 172px;
  .v-input {
   width: 172px;
  }
  input::placeholder {
   color: var(--black-color);
  }
 }
}
</style>
